import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=e7edb3ce"
import script from "./checkbox-group.vue?vue&type=script&lang=js"
export * from "./checkbox-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports